// 3rd-party modules
import moment from "moment-timezone";
import { isMobile } from "react-device-detect";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";

// project modules
import { apiCall } from "../../../helpers/apiHelper";
import Button from "../../shared/button";
import CustomChart from "../../shared/chart/chart";
import DashboardWidget from "../../global/dashboardWidget";
import DataTable, { TableColumn } from "../../shared/list/dataTable";
import Loader from "../../shared/loader";
import Select from "../../shared/inputs/select";

// apis
import * as AccountKiboshDeviceApi from '../../../apis/accountKiboshDeviceApi';
import * as DashApi from '../../../apis/dashApi';

// models
import { Account } from "../../../models/account";
import { AccountDeviceGroup } from '../../../models/accountDeviceGroup';
import { AccountKiboshDevice } from "../../../models/accountKiboshDevice";
import { AccountDevice } from "../../../models/accountDevice";
import { DataSourceRequest, FilterDescriptor, PaginationDescriptor, SortDescriptor } from "../../../models/dataSourceRequest";

// defines
import { CONSTANTS } from "../../../helpers/defines";

type Props = {
  account?: Account;
  kiboshDeviceReference?: string;
  deviceGroupReference?: string;
  onCancel?: () => void;
  onSave?: (account: Account) => void;
};

export default function AccountGpsLogs({ account,  kiboshDeviceReference, deviceGroupReference, onCancel, onSave }: Props) {

  const [accountKiboshDevices, setAccountKiboshDevices] = useState<AccountKiboshDevice[]>([]);
  const [accountDevices, setAccountDevices] = useState<AccountDevice[]|AccountKiboshDevice[]>([]);
  const [currentAccountKiboshDeviceReference, setCurrentAccountKiboshDeviceReference] = useState<string>("");
  const [currentAccountDeviceReference, setCurrentAccountDeviceReference] = useState<string>("");
  const [gpsDays, setGpsDays] = useState<string[]>([]);
  const [gpsLogs, setGpsLogs] = useState<any[]>([]);
  const [currentGpsDay, setCurrentGpsDay] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [loadingAccountKiboshDevices, setLoadingAccountKiboshDevices] = useState(false);
  const [loadingGpsDays, setLoadingGpsDays] = useState(false);
  const [regetFullData, setRegetFullData] = useState<boolean>(false);
  const [locationLink, setLocationLink] = useState<string>("about:blank")
  let abortController = new AbortController();



  useEffect(() => {
    if (regetFullData) {
      if (!kiboshDeviceReference) {
        getAccountKiboshDevicesAsync();
      } else {
        getAccountDevicesAsync();
      }
      setRegetFullData(false);
    }
  }, [regetFullData]);

  useEffect(() => {
    setRegetFullData(true);

  }, [])




  const getAccountKiboshDevicesAsync = async () => {
    setAccountKiboshDevices(await getAccountKiboshDevices({}, abortController.signal));
  }

  const getAccountKiboshDevices = async (request?: DataSourceRequest, abortSignal?: AbortSignal) => {
    setLoadingAccountKiboshDevices(true);
    const response = await apiCall(AccountKiboshDeviceApi.getAccountKiboshDevices(account?.accountId!, request, abortSignal));
    setLoadingAccountKiboshDevices(false);

    return response.success ? AccountKiboshDevice.toArrayOfClass(response.data?.value || []) : [];
  };


 const getAccountDevicesAsync = async (routerRef?: string) => {
    setAccountDevices(await getAccountDevices(routerRef, abortController.signal));
  }

  const getAccountDevices = async (routerRef?: string, abortSignal?: AbortSignal) => {
    setLoadingAccountKiboshDevices(true);

    if( kiboshDeviceReference!.startsWith("d-") ) {



      const gResponse = await apiCall(DashApi.getDeviceGroups(kiboshDeviceReference!, false, abortController.signal));
      const gData = gResponse.success ? AccountDeviceGroup.toArrayOfClass(gResponse.data?.value || []).sort((a: any, b: any) => a.id - b.id) : []


      let idsInGroups:any = {} 
      let idsInCurrentGroup:any = {}
      gData.forEach(group => {
        if(group.clientIds != null) {
          group.clientIds!.forEach( cl_id => {
            idsInGroups[cl_id] = true ;
            if(group.id == deviceGroupReference) {
              idsInCurrentGroup[cl_id] = true ;
            }
          });
        }
      });



      const kdResponse = await apiCall(AccountKiboshDeviceApi.getAccountKiboshDevices(account?.accountId!, {}, abortSignal));
      const kdData = kdResponse.success ? AccountKiboshDevice.toArrayOfClass(kdResponse.data?.value || []) : [];

      let groupDevices = kdData.filter( (d:any) => { return d.kiboshDeviceTypeCode?.toLowerCase() == "vpn" && d.hasActiveSubscription! && (deviceGroupReference == null || deviceGroupReference == "" || idsInCurrentGroup[ d.kiboshDeviceReference! ] == true); } )

      setLoadingAccountKiboshDevices(false);


      groupDevices =  groupDevices.sort((a: any, b: any) => a.kiboshDeviceReference!.toLowerCase().localeCompare( b.kiboshDeviceReference!.toLowerCase()) );
      setCurrentAccountDeviceReference( "" + groupDevices[0].kiboshDeviceReference );

      
      return groupDevices ;


    } else {
      const response = await apiCall(DashApi.getClientDevices(kiboshDeviceReference || currentAccountKiboshDeviceReference || routerRef!, abortSignal));

      let data = response.success ? AccountDevice.toArrayOfClass(response.data?.value || []) : [];


      if (deviceGroupReference && !(kiboshDeviceReference!.startsWith("d-")) ) {
        data = data.filter(x => x.groupId === deviceGroupReference && x.isVpn );
      } else {
        data = data.filter((x: any) => { return x.isVpn ; } )
      }



      if(data.length > 0 && currentAccountDeviceReference == null) {
        setCurrentAccountDeviceReference( "" + data[0].id );
        getGpsDaysAsync();
      } else if(currentAccountDeviceReference != null) {
        getGpsDaysAsync();
      }

      setLoadingAccountKiboshDevices(false);

      return data ;
    }
  };




  const getGpsDaysAsync = async (loadDay?: string | null, loadDevice?: string | null) => {
    setGpsDays(await getGpsDays(abortController.signal, loadDay, loadDevice))
  }

  const getGpsDays = async (abortSignal?: AbortSignal, loadDay?: string | null, loadDevice?: string | null) => {
    setLoadingGpsDays(true);
    setLoading(true);
    const response = await apiCall(DashApi.getVpnMonitorDays(kiboshDeviceReference || currentAccountKiboshDeviceReference, loadDevice || currentAccountDeviceReference, abortSignal));



    let ld = response.success ? response.data?.value || [] : [];
    let cd = loadDay ? loadDay : currentGpsDay;

   
    cd = !cd && ld.length > 0 ? ld[0] : cd
    if( !currentGpsDay && !loadDay) {
      setCurrentGpsDay(cd)
    }

    if(!!cd) {
      const response2 = await apiCall(DashApi.getVpnMonitorEvents(kiboshDeviceReference || currentAccountKiboshDeviceReference, loadDevice || currentAccountDeviceReference, cd, abortSignal));
      if(response2.success && response2.data?.value != null) {

        let validGps = response2.data?.value.filter( (x:any) => x.latitude != null && x.longitude != null  )
        let finalGps = [ ]

        if(validGps.length > 0) {
          finalGps.push( validGps.shift() )
          let gpsIntervalData:any = {}
          while(validGps.length > 0) { 
            let nextGps = validGps.shift();
            let m = moment(nextGps.event_time)
            let interval = m.add( -1 *( m.minutes() % 15), "minutes")
            gpsIntervalData[ interval.format("YYYY-MM-DD-HH-mm") ] = nextGps
          }
          Object.keys(gpsIntervalData).sort().reverse().forEach( key => { 
            finalGps.push( gpsIntervalData[key] )
          });

          setLocationLink("https://maps.google.com/maps?q=" + finalGps[0].latitude + "," + finalGps[0].longitude + "&t=&z=14&ie=UTF8&iwloc=&output=embed")

        }
        setGpsLogs(finalGps);


      }
    }
   
    setLoadingGpsDays(false);
    setLoading(false);

    return ld
  };




  const onAccountKiboshDeviceChange = (kiboshDeviceReference: any) => {
    setCurrentAccountKiboshDeviceReference(kiboshDeviceReference);
  }


  const onLogDaysChange = async (day:any) => {
    setCurrentGpsDay(day);
    getGpsDaysAsync(day)
  }

  const onAccountDeviceChange = (deviceReference: any) => {
    setCurrentAccountDeviceReference(deviceReference);
    getGpsDaysAsync(null, deviceReference)
  }

  const getBlockableOption = (blockableItem:any) => {
    if (blockableItem instanceof AccountKiboshDevice) {
      return { text: "" + blockableItem.kiboshDeviceReference!, value: "" + blockableItem.kiboshDeviceReference! };

    } else {
      let isProfile = blockableItem["client_ids"] != null
      let isVpn = ( blockableItem["is_vpn"] == true || blockableItem["isVpn"] == true)
      let bv =  blockableItem.id! 
      let bt  =  blockableItem.name!
      bt = bt == null ? "" + blockableItem.id! : bt
      bt = isProfile ? bt + " (Profile)" : bt
      bt = isVpn ? bt  + " (VPN)" : bt
      bt = (!isProfile) && (!isVpn) && blockableItem.ip ? bt + " (" + blockableItem.ip.replace("disconnected", "offline") + ")" : bt
      return { text: bt, value: "" + bv }
    }
  };

  return (
    <>
      {loading && <Loader /> }
      <view data-scroll="" >
        <group data-space="15" data-gap="15" data-border="" data-align="center" > 
            <>
              {!kiboshDeviceReference && (
                <>
                  <Select
                    autoComplete=""
                    label="Kibosh Device"
                    labelPosition="left"
                    dataLength="forcefit"
                    dataMinLength="200"
                    onChange={onAccountKiboshDeviceChange}
                    loading={loadingAccountKiboshDevices}
                    allowSearch={true}
                    options={
                      accountKiboshDevices?.map((item) => {
                        return {
                          text: `${item.kiboshDeviceName!} (${item.kiboshDeviceReference!})`,
                          value: item.kiboshDeviceReference!,
                        };
                      }) || []
                    }
                    button={
                      <Button
                        material
                        icon="refresh"
                        onClick={getAccountKiboshDevicesAsync}
                      />
                    }
                  />
                </>
              )}
              {
                  <>
                    <Select
                      autoComplete=""
                      disabled={
                        loadingAccountKiboshDevices ||
                        !(
                          kiboshDeviceReference ||
                          currentAccountKiboshDeviceReference
                        )
                      }
                      label="Device"
                      placeholder="Select Device"
                      labelPosition="left"
                      dataLength="425"
                      dataMinLength="425"
                      onChange={onAccountDeviceChange}
                      loading={loadingAccountKiboshDevices}
                      allowSearch={true}
                      options={
                        accountDevices?.map((item) => { return getBlockableOption(item) }) || []
                      }
                      //value={currentAccountDeviceReference}
                      button={
                        <Button
                          material
                          icon="refresh"
                          onClick={getAccountDevicesAsync}
                        />
                      }
                    />
                  </>
                }

          <Select
            value={currentGpsDay} //?
            placeholder="Select Day"
            autoComplete=""
            label="Date"
            labelPosition="left"
            dataLength="forcefit"
            dataMinLength="425"
            onChange={onLogDaysChange}
            loading={loadingGpsDays}
            allowSearch={true}
            options={gpsDays || []}
            button={
              <Button
                material
                icon="refresh"
                onClick={getGpsDaysAsync}
              />
            }
          />
          <Button
            data-position="right"
            material
            icon="refresh"
            text="Refresh"
            outline
            onClick={getGpsDaysAsync}
          />
          </>
        
        </group>









          <group
            data-gap="10"
            data-space="15"
            data-background="highlight"
            data-border=""
          >
            <div style={{ display:"block", width:"550px" }} >
              <span style={{ float:"left",clear:"left", width:"80px" }} >
              { gpsLogs.map((gps,index) => ( 
                <div data-color="main" style={{ display:"block", textDecoration: "underline" }} >
                  <a href="javascript:;" onClick={ () => { setLocationLink("https://maps.google.com/maps?q=" + gps.latitude + "," + gps.longitude + "&t=&z=14&ie=UTF8&iwloc=&output=embed") } } >
                    { moment(gps.event_time).format(CONSTANTS.DEFAULT_TIME_FORMAT) }
                  </a>
                  <br/>
                </div>  
                ))
              }
              </span>
	      <span style={{ display:"inline", width:"400px" }} >
                <iframe style={{ display:"block", width:"400px", height:"400px"}} src={ locationLink }></iframe>
              </span>
            </div>
          </group>


      </view>
    </>
  );
}
